import { useQuery } from '@tanstack/react-query';
import {
  allDistrictListQueryOptions,
  districtListQueryOptions,
  thanaListQueryOptions,
} from '@/features/geo/api/geo.api';

interface UseDistrictThanaFilterOptionsParams {
  isEnabled: boolean;
  districtId: number | undefined;
  divisionId?: number | undefined;
}

export function useDistrictThanaFilterOptions({
  isEnabled,
  districtId,
  divisionId,
}: UseDistrictThanaFilterOptionsParams) {
  const hasDivision = divisionId !== undefined;
  const allDistrictsQuery = useQuery({
    ...allDistrictListQueryOptions(),
    enabled: isEnabled && !hasDivision,
  });
  const divisionDistrictsQuery = useQuery({
    ...districtListQueryOptions(divisionId ?? 0),
    enabled: isEnabled && hasDivision,
  });
  const { data: thanas, isError: hasThanasError } = useQuery({
    ...thanaListQueryOptions(districtId ?? 0),
    enabled: isEnabled && districtId !== undefined,
  });
  const districtsQuery = hasDivision ? divisionDistrictsQuery : allDistrictsQuery;

  return {
    districts: districtsQuery.data,
    thanas,
    hasOptionsError: districtsQuery.isError || hasThanasError,
  };
}
